module.exports = __webpack_public_path__ + "static/media/m1.16b61f62.png";